import React from 'react';
import { withTranslation } from 'language/i18n';
import PropTypes from 'prop-types';

import Layout from 'components/partials/Layout';
import Breadcrumb from 'components/Breadcrumb';
import ContactUs from './components/ContactUs';

const refundConditions = ({ t }) => {
  const breadcrumbs = [
    {
      label: t('homepage'),
      url: '/',
    },
    {
      label: t('refundConditions'),
      url: '/content/refund-conditions',
    },
  ];

  return (
    <main className="has-header">
      <div className="container">
        <div className="row mt-4 mb-4 mt-lg-3 mb-lg-3">
          <div className="col">
            <Breadcrumb links={breadcrumbs} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-10 col-lg-11 mt-3 mt-md-0">
            <div className="row mb-20">
              <div className="col">
                <h1 className="h1">Lorem</h1>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15">
                <p>
                  Nulla vitae elit libero, a pharetra augue. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed posuere consectetur est at lobortis. Cras mattis consectetur purus sit amet fermentum.
                </p>
                <p>
                  Aenean lacinia bibendum nulla sed consectetur. Maecenas sed diam eget risus varius blandit sit amet non magna.
                  Cras mattis consectetur purus sit amet fermentum. Integer posuere erat a ante venenatis dapibus posuere velit aliquet.
                  Cras justo odio, dapibus ac facilisis in, egestas eget quam. Curabitur blandit tempus porttitor. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus.
                </p>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15">
                <h2 className="h5">Ipsum</h2>
              </div>
              <div className="col-15">
                <p>
                  Praesent commodo cursus magna, vel scelerisque nisl consectetur et.
                  Etiam porta sem malesuada magna mollis euismod. Vestibulum id ligula porta felis euismod semper. Donec ullamcorper nulla non metus auctor fringilla.
                  Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.
                </p>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15">
                <h2 className="h5">Dolor</h2>
              </div>
              <div className="col-15">
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Curabitur convallis lobortis eros, nec viverra est ornare vel. In sit amet sapien eu enim bibendum posuere.
                  Sed cursus enim eget massa auctor posuere.
                  Fusce dictum ipsum in dapibus pellentesque.
                </p>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15">
                <h2 className="h5">Sit Amet</h2>
              </div>
              <div className="col-15">
                <p>
                  In scelerisque fringilla viverra.
                  Vivamus iaculis sem sit amet nibh commodo, et placerat erat ullamcorper.
                  Nunc ornare quam nulla, eget porta massa lobortis quis.
                  Nulla eleifend elit et vestibulum pharetra. Aliquam felis felis, congue tincidunt turpis mollis, fermentum tristique urna.
                </p>
              </div>
            </div>
            <ContactUs about="İade Koşulları ile" />
          </div>
        </div>
      </div>
    </main>
  );
};

refundConditions.propTypes = {
  t: PropTypes.func,
};

export const getServerSideProps = async () => {
  return {
    props: {
      blackHeader: true,
      headTitle: 'Ekspertiz ve Değerleme',
    },
  };
};

refundConditions.Layout = Layout;

export default withTranslation('common')(refundConditions);
